export default __webpack_public_path__ + "static/media/Icons_Bin Icon.6e57bd7d.svg";